import isCircuitWorkoutSectionUtil from '../../../model/utils/is-circuit'
import { setIdReduxAction } from '../../../../redux/actions/set-id'
import getInstanceReduxUtil from '../../../../redux/utils/get-instance'
import updateCurrentSetIndexWorkoutExerciseAction
  from '../../../../workout-exercise/redux/actions/update-current-set-index'
import { updateCurrentRoundIndexWorkoutExerciseAction } from '../update-current-round-index'
import WORKOUT_SECTIONS_ACTION from '../../constants/action'
import WORKOUT_SECTIONS_PATH from '../../constants/path'
import getByIdWorkoutSectionSelector from '../../selectors/get-by-id'

function updateCurrentWorkoutSectionAction (instanceOrId) {
  return (dispatch, getState) => {
    let instance
    if (typeof instanceOrId === 'number') {
      instance = getByIdWorkoutSectionSelector(instanceOrId)(getState())
    } else {
      instance = instanceOrId
    }
    dispatch(setIdReduxAction({
      type: instance
        ? WORKOUT_SECTIONS_ACTION.UPDATE_CURRENT
        : WORKOUT_SECTIONS_ACTION.DELETE_CURRENT,
      payload: {
        path: WORKOUT_SECTIONS_PATH.CURRENT,
        instance
      }
    }))
    instance = getInstanceReduxUtil(getState(), instance)
    if (isCircuitWorkoutSectionUtil(instance)) {
      dispatch(updateCurrentRoundIndexWorkoutExerciseAction(0))
    } else {
      dispatch(updateCurrentSetIndexWorkoutExerciseAction(0))
    }
  }
}

export default updateCurrentWorkoutSectionAction
